import React from "react";
import "./Kits.scss";
import Kitsimg1 from "./assets/images/kit_img1.png";
import Kitsimg2 from "./assets/images/kit_img1.png";
import Kitsimg3 from "./assets/images/kit_img1.png";
import Kitsimg4 from "./assets/images/kit_img1.png";
import Kitsimg5 from "./assets/images/kit_img1.png";
import Kitsimg6 from "./assets/images/kit_img1.png";
import Kitsimg7 from "./assets/images/kit_img1.png";
import Kitsimg8 from "./assets/images/kit_img1.png";
import Kitsimg9 from "./assets/images/kit_img1.png";
import Kitsimg10 from "./assets/images/kit_img1.png";
import Kitsimg11 from "./assets/images/kit_img1.png";
import Kitsimg12 from "./assets/images/kit_img1.png";
import Kitsimg13 from "./assets/images/kit_img1.png";
import Kitsimg14 from "./assets/images/kit_img1.png";
import Kitsimg15 from "./assets/images/kit_img1.png";
import Kitsimg16 from "./assets/images/kit_img1.png";

import KitsCard from "./Kitscard"

const Kits = () => {
    const data = [
        {
            id: 1,
            image: Kitsimg1,
            link: null,
            btnname: "DOWNLOAD ARTURA Z201",
        },
        {
            id: 2,
            image: Kitsimg2,
            link: null,
            btnname: "DOWNLOAD DANDOLO",
        },
        {
            id: 3,
            image: Kitsimg3,
            link: null,
            btnname: "DOWNLOAD FOORARA",
        },
        {
            id: 4,
            image: Kitsimg4,
            link: null,
            btnname: "DOWNLOAD FROOZKIMO",
        },
        {
            id: 5,
            image: Kitsimg5,
            link: null,
            btnname: "DOWNLOAD GAS STATION",
        },
        {
            id: 6,
            image: Kitsimg6,
            link: null,
            btnname: "DOWNLOAD GATNATAR",
        },
        {
            id: 7,
            image: Kitsimg7,
            link: null,
            btnname: "DOWNLOAD MAKABALA",
        },
        {
            id: 8,
            image: Kitsimg8,
            link: null,
            btnname: "DOWNLOAD MALAKAH",
        },
        {
            id: 9,
            image: Kitsimg9,
            link: null,
            btnname: "DOWNLOAD MALTASS",
        },
        {
            id: 10,
            image: Kitsimg10,
            link: null,
            btnname: "DOWNLOAD METAVERSE PORTAL",
        },
        {
            id: 11,
            image: Kitsimg11,
            link: null,
            btnname: "DOWNLOAD NILMARA GALAXY",
        },
        {
            id: 12,
            image: Kitsimg12,
            link: null,
            btnname: "DOWNLOAD PANKORA",
        },
        {
            id: 13,
            image: Kitsimg13,
            link: null,
            btnname: "DOWNLOAD RISE OF THE RENEGADES",
        },
        {
            id: 14,
            image: Kitsimg14,
            link: null,
            btnname: "DOWNLOAD SANDAGA",
        },
        {
            id: 15,
            image: Kitsimg15,
            link: null,
            btnname: "DOWNLOAD WONGODI",
        },
        {
            id: 16,
            image: Kitsimg16,
            link: null,
            btnname: "DOWNLOAD ZAYZIN",
        },
    ];

    return (
        <>
            <div className="kits_section">
                {
                    data.map((car) => {
                        return (
                            <>
                                {
                                    <KitsCard image={car.image} btnname={car.btnname} />
                                }
                            </>
                        )
                    })
                }
            </div>
        </>
    );
};

export default Kits;
